import SingleStat from './SingleStat'

export default SingleStat